import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Download, Upload, Loader2, FileJson } from 'lucide-react';

export function FileExportRestore({
  exporting,
  onExport,
  restoreFile,
  onFileChange,
  onRestoreClick,
  formatBytes,
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <FileJson className="w-4 h-4" />
          File Export & Restore
        </CardTitle>
        <CardDescription>Export all data to a JSON file or restore from a previously exported file</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3 p-4 bg-muted/30 rounded-lg border">
            <div className="flex items-center gap-2">
              <Download className="w-4 h-4 text-primary" />
              <h4 className="font-medium text-sm">Export Data</h4>
            </div>
            <p className="text-xs text-muted-foreground">
              Streams the full database to a compressed <code className="text-[10px]">.jsonl.gz</code> file. Works for databases of any size.
            </p>
            <Button
              onClick={onExport}
              disabled={exporting}
              variant="outline"
              className="w-full"
              data-testid="btn-export-backup-file"
            >
              {exporting ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Exporting...</>
              ) : (
                <><Download className="w-4 h-4 mr-2" /> Export All Data to File</>
              )}
            </Button>
          </div>

          <div className="space-y-3 p-4 bg-muted/30 rounded-lg border">
            <div className="flex items-center gap-2">
              <Upload className="w-4 h-4 text-primary" />
              <h4 className="font-medium text-sm">Restore from File</h4>
            </div>
            <p className="text-xs text-muted-foreground">
              Upload a previously exported <code className="text-[10px]">.jsonl.gz</code> (or legacy <code className="text-[10px]">.json</code>) backup. A safety restore point is created automatically.
            </p>
            <div className="flex gap-2">
              <Input
                type="file"
                accept=".json,.gz,.jsonl"
                onChange={onFileChange}
                className="flex-1"
                data-testid="restore-file-input"
              />
              <Button
                variant="outline"
                disabled={!restoreFile}
                onClick={onRestoreClick}
                data-testid="btn-restore-from-file"
              >
                <Upload className="w-4 h-4" />
              </Button>
            </div>
            {restoreFile && (
              <p className="text-xs text-muted-foreground">
                Selected: {restoreFile.name} ({formatBytes(restoreFile.size)})
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
